<p-dialog [(visible)]="displayCurrencyDialog" [modal]="true" [closable]="true" [header]="'currencyExchangeDialog.currencyExchange' | transloco"
  [style]="{ width: '520px' }" (onHide)="closeDialog.emit()" [baseZIndex]="10000"
  [contentStyle]="{ 'overflow': 'visible' }">

  <!-- Store Selection -->
  @if (selectedPlatform === 'WooCommerce' || selectedPlatform === 'SquareSpace' || selectedPlatform === 'Shopify') {
    <div class="mb-1 px-2"
      >
      <p-dropdown id="storeDropdown" [options]="getStoreOptions()" [optionLabel]="getStoreOptionLabel()" optionValue="Id"
        [placeholder]="'currencyExchangeDialog.selectStore' | transloco: { platform: selectedPlatform }" (onChange)="onStoreChange($event)" [showClear]="true"
        [filter]="true">
        <ng-template pTemplate="empty">
          <div class="p-2 text-center">
            {{ 'currencyExchangeDialog.noStoresFound' | transloco: { platform: selectedPlatform } }}
          </div>
        </ng-template>
      </p-dropdown>
      <small class="text-muted d-block mt-1">{{ 'currencyExchangeDialog.chooseStore' | transloco }}</small>
    </div>
  }
  @if (selectedPlatform === 'SquareSpace' && selectedStoreId) {
    <div class="mb-1 px-2">
      <p-dropdown id="pagesDropdown" [placeholder]="'currencyExchangeDialog.selectPage' | transloco" [options]="squareSpaceStorePages" optionLabel="title"
        optionValue="id" (onChange)="onSquareSpacePageChange($event)">
      </p-dropdown>
      <small class="text-muted d-block mt-1">{{ 'currencyExchangeDialog.choosePage' | transloco }}</small>
    </div>
  }

  <!-- Loader -->
  @if (isLoading && (selectedStoreId || (selectedPlatform !== 'WooCommerce' && selectedPlatform !== 'Shopify' && selectedPlatform !== 'SquareSpace'))) {
    <div
      style="min-height: 200px;" class="d-flex flex-column align-items-center justify-content-center">
      <p-progressSpinner [style]="{ width: '50px', height: '50px' }"></p-progressSpinner>
      <p class="mt-2 text-muted" style="font-size: 1.1rem; font-weight: 500;">{{ 'currencyExchangeDialog.fetchingRates' | transloco }}</p>
    </div>
  }

  <!-- Main Content -->
  @if (!isLoading && (selectedPlatform !== 'WooCommerce' && selectedPlatform !== 'Shopify' || selectedStoreId)) {
    <div
      class="dialog-content p-3">
      <!-- If currencies are different, show all currency details -->
      @if (exchangeRateData?.ResponseObject?.Success && exchangeRateData?.IsPlateformCurrencyIsDifferent;) {
        <!-- Info Section -->
        <div class="mb-1">
          <p class="text-muted" style="font-size: 1.15rem;">
            {{ 'currencyExchangeDialog.currentExchangeRate' | transloco: { rate: (exchangeRateData?.ExchangeRate | number: '1.2-2') } }}
          </p>
          <p class="text-muted">
            {{ 'currencyExchangeDialog.pricedInfo' | transloco: { baseCurrency: exchangeRateData?.BaseCurrencySymbol, platform: exchangeRateData?.Plateform, targetCurrency: exchangeRateData?.TargetCurrencySymbol } }}
          </p>
        </div>
        <!-- Instructions -->
        <div class="mb-1 text-muted" style="font-size: 0.9rem;">
          <p>{{ 'currencyExchangeDialog.fetchLatestRateFrom' | transloco }}
            <a href="{{ exchangeRateData?.ExchageRateSite }}" target="_blank">openexchangerates.org</a>
            {{ 'currencyExchangeDialog.orEnterManually' | transloco }}
          </p>
        </div>
        <!-- Price Info Form -->
        <div class="form-layout">
          <!-- Base Price -->
          <div class="form-group mb-1">
            <label for="priceBase" class="form-label">{{ 'currencyExchangeDialog.priceWithCurrency' | transloco: { currency: exchangeRateData?.BaseCurrencySymbol } }}</label>
            <div class="input-group">
              <span class="input-group-text"><i class="pi pi-dollar"></i></span>
              <input id="priceBase" type="text" class="form-control" [value]="Productprice| number: '1.2-2'"
                [placeholder]="'currencyExchangeDialog.enterPrice' | transloco" disabled />
              </div>
            </div>
            <!-- Converted Price & Exchange Rate -->
            <div class="form-group mb-1">
              <label for="priceTarget" class="form-label">{{ 'currencyExchangeDialog.priceWithCurrency' | transloco: { currency: exchangeRateData?.TargetCurrencySymbol } }}</label>
              <div class="input-group">
                <span class="input-group-text"><i class="pi pi-dollar"></i></span>
                <input id="priceTarget" type="number" class="form-control"
                  placeholder="{{ ConvertedPrice | number: '1.2-2' }}" disabled />
                </div>
              </div>
              <div class="form-group mb-1">
                <label for="exchangeRate" class="form-label">{{ 'currencyExchangeDialog.exchangeRate' | transloco }}</label>
                <div class="input-group">
                  <input id="exchangeRate" type="text" class="form-control"
                    placeholder="{{ exchangeRateData?.BaseCurrencySymbol }} 1 = {{ exchangeRateData?.TargetCurrencySymbol }} {{ exchangeRateData?.ExchangeRate | number: '1.2-2' }}"
                    disabled />
                  </div>
                </div>
              </div>
            }
            <!-- If currencies are the same, show only message and button -->
            @if (exchangeRateData?.ResponseObject?.Success && !exchangeRateData?.IsPlateformCurrencyIsDifferent) {
              <div class="text-success mb-2">
                {{ exchangeRateData?.ResponseObject?.ResponseMessage || ('currencyExchangeDialog.currencyMatches' | transloco) }}
              </div>
              <div class="d-flex justify-content-end">
                <p-button type="button" severity="success" (click)="onUseNewRate()" [disabled]="isContinueButtonDisabled"
                class="p-button-sm" [label]="'currencyExchangeDialog.syncAndContinue' | transloco"></p-button>
              </div>
            }
          </div>
        }

        <!-- Footer Buttons -->
        @if (exchangeRateData?.ResponseObject?.Success && exchangeRateData?.IsPlateformCurrencyIsDifferent) {
          @if (!isLoading && (selectedPlatform !== 'WooCommerce' && selectedPlatform !== 'Shopify' || selectedStoreId)) {
            <div class="d-flex justify-content-end p-3"
              >
              <p-button [label]="'currencyExchangeDialog.continueWithoutRate' | transloco" [outlined]="true" severity="secondary"
              (click)="onUseManualRate()"></p-button>
              <p-button type="button" [outlined]="true" severity="success" (click)="onUseNewRate()"
                [disabled]="isContinueButtonDisabled" class="p-button-sm ms-2" [label]="'currencyExchangeDialog.continueWithRate' | transloco">
              </p-button>
            </div>
          }
        }

      </p-dialog>

      @if (authConfig?.IsArtist) {
        @if (ArtistProductSummary) {
          <app-single-product-sync [AccountId]="selectedStoreId"
            [selectedProductId]="ArtistProductSummary.Id" [ArtistProductSummary]="ArtistProductSummary"
            [SquareSpaceStoreId]="selectedStoreId" [SquareSpaceStorePageId]="selectedSquareSpaceStorePage">
          </app-single-product-sync>
        }
      } @else {
        @if (selectedItem) {
          <app-single-product-sync [consignmentId]="selectedItem.ConsignmentId"
            [AccountId]="selectedStoreId" [selectedProductId]="selectedItem.Id" [selectedItem]="selectedItem"
            [SquareSpaceStoreId]="selectedStoreId" [SquareSpaceStorePageId]="selectedSquareSpaceStorePage">
          </app-single-product-sync>
        }
      }

      @if (selectedItem) {
        <app-single-product-sync [consignmentId]="selectedItem.ConsignmentId"
          [AccountId]="selectedStoreId" [selectedProductId]="selectedItem.Id" [selectedItem]="selectedItem"
          [SquareSpaceStoreId]="selectedStoreId" [SquareSpaceStorePageId]="selectedSquareSpaceStorePage">
        </app-single-product-sync>
      }